'use client';

import { toAbsoluteSiteThumbnailUrl } from '@/constants/shareLink';

import { SiteThumb } from './SiteThumb';

interface FullShareViewSiteDetailsProps {
  siteName?: string;
  imageUrl?: string;
  siteUrl?: string;
}

export function FullShareViewSiteDetails({
  siteName,
  imageUrl,
  siteUrl,
}: FullShareViewSiteDetailsProps) {
  const thumbSrc = toAbsoluteSiteThumbnailUrl(imageUrl);

  return (
    <div data-hook="share-site-details" className="flex items-center gap-5">
      <SiteThumb key={thumbSrc ?? ''} src={thumbSrc} />
      <div className="flex min-w-0 flex-col">
        {siteName ? (
          <span data-hook="site-name" className="text-base text-[#151414]">
            {siteName}
          </span>
        ) : null}
        {siteUrl ? (
          <span
            data-hook="site-url"
            className="truncate text-sm text-[#767574]"
          >
            {siteUrl}
          </span>
        ) : null}
      </div>
    </div>
  );
}
